import request from '@/utils/request'; // 假设 request.ts 位于 utils 目录下

// 假设的类型定义 (应与 website_api.py 中的 Pydantic Schema 对应)
interface Category {
    id: number;
    name: string;
}

interface NewsListItem {
    id: number;
    title: string;
    summary: string;
    cover_image: string;
    publish_time: string;
    category: Category;
}

interface NewsDetail {
    id: number;
    title: string;
    summary: string;
    content: string;
    cover_image: string;
    publish_time: string;
    source: string;
    author: string;
    hit_count: number;
    category: Category;
}

interface NoticeListItem {
    id: number;
    title: string;
    summary: string;
    publish_time: string;
    category: Category;
}

interface NoticeDetail {
    id: number;
    title: string;
    summary: string;
    content: string;
    cover_image: string;
    publish_time: string;
    source: string;
    author: string;
    hit_count: number;
    file_path: string | null;
    category: Category;
}

// --- 接口定义 ---

/**
 * 获取新闻列表
 * @param params 查询参数 (lang, page, size, category_id)
 */
export const getNewsListApi = (params: { lang: string, page: number, size: number, category_id?: number | null }): Promise<NewsListItem[]> => {
    return request.get<NewsListItem[]>('/v1/news/list', params);
};
export const getNewsCategoryApi = (params: { lang: string}): Promise<NewsListItem[]> => {
    return request.get<NewsListItem[]>('/v1/news/categories', params);
};
export const getNewsDetailApi = (news_id: number, params: { lang: string }): Promise<NewsDetail> => {
    // 修正：request.get的第二个参数是config对象，参数需要放在params属性中
    return request.get<NewsDetail>(`/v1/news/${news_id}`, { params });
};

/**
 * 获取公告列表
 * @param params 查询参数 (lang, page, size, category_id)
 */
export const getNoticeListApi = (params: { lang: string, page: number, size: number, category_id?: number | null }): Promise<NoticeListItem[]> => {
    return request.get<NoticeListItem[]>('/v1/notice/list', params);
};
export const getNoticeCategoryApi = (params: { lang: string}): Promise<NewsListItem[]> => {
    return request.get<NewsListItem[]>('/v1/notice/categories', params);
};
/**
 * 获取公告详情
 * @param notice_id 公告ID
 * @param params 查询参数 (lang)
 */
export const getNoticeDetailApi = (notice_id: number, params: { lang: string }): Promise<NoticeDetail> => {
    return request.get<NoticeDetail>(`/v1/notice/${notice_id}`, params);
};

export const getSinglePageContent = (params: { lang: string, path: string }): Promise<NoticeDetail> => {
    return request.get<NoticeDetail>(`/v1/page/content`, params);
};

export const getHomeConfigApi = (params: { lang: string }): Promise<NoticeDetail> => {
    return request.get<any>(`/v1/home/config`, params);
};
